import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type BuyShopItemRequest = {
  skuId: number
  cardToken: string
  recipient?: string
  message?: string
  giftCard?: string
  promoCode?: string
}

export const buyShopItem = async (data: BuyShopItemRequest) => {
  const response = await authAPI.post('/shop/buy', data)
  return response.data
}

export const useBuyShopItem = () => useMutation({ mutationFn: buyShopItem })
